export enum PanelState {
    Check,
    Decline,
    None,
}
